import { render } from "./TaxReportOwners.vue?vue&type=template&id=c6cc289a&scoped=true"
import script from "./TaxReportOwners.vue?vue&type=script&lang=js"
export * from "./TaxReportOwners.vue?vue&type=script&lang=js"

import "./TaxReportOwners.vue?vue&type=style&index=0&id=c6cc289a&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6cc289a"]])

export default __exports__